import { useTranslator } from '@bluebeam/react-i18n';
import SearchInput from 'components/inputs/SearchInput';
import AppStoreContext from 'contexts/AppStoreContext';
import React, { useContext } from 'react';
import { PunchList } from 'records/Punch';
import withAppStore, { WithAppStoreProps } from 'utils/withAppStore';
import SortPopover from './SortPopover';

interface PunchListHeaderProps extends WithAppStoreProps {
  punches: PunchList;
  onShowAll: () => void;
}

const PunchListHeader: React.FC<PunchListHeaderProps> = ({
  punches,
  onShowAll,
}) => {
  const { translate } = useTranslator(['mapView']);
  const { state: appState, actions } = useContext(AppStoreContext);
  const { punchQuery } = appState;

  const handleSearchChange = (searchString: string): void => {
    const nextPunchQuery = punchQuery.set('search', searchString);
    actions.setPunchQuery(nextPunchQuery);
  };

  const filteredApplied = punchQuery.search.length > 0;

  return (
    <div className="px4 py3 bb-2">
      <div className="row justify-between mb4">
        <div className="bold">
          {`${translate('mapView:punchListHeader.allItems')} (${punches.size})`}
        </div>
        <div>
          {filteredApplied ? (
            <div
              className="bold font-size-4 color-primary cursor-pointer"
              onClick={onShowAll}
            >
              {translate('mapView:punchListHeader.showAll')}
            </div>
          ) : null}
        </div>
      </div>
      <div className="row">
        <div className="grow-1 mr3">
          <SearchInput
            onChange={handleSearchChange}
            value={appState.punchQuery.search}
            id="punch-subheader-search"
          />
        </div>
        <div>
          <SortPopover />
        </div>
      </div>
    </div>
  );
};

export default withAppStore<PunchListHeaderProps>(PunchListHeader);
